<template>
    <rkm-overlay>
        <div class="content">
            <template v-if="loaded">
                <AssinaturaEletronicaInstacacao
                    v-if="data.assinaturaEletronicaAtiva"
                    ref="AssinaturaEletronicaInstacacao"
                />
            </template>
        </div>
    </rkm-overlay>
</template>

<script>
// Components.
import AssinaturaEletronicaInstacacao from '@/components/assinatura-eletronica/components/instalacao/Form'

// Others.
import { mapActions } from 'vuex'
import { repository, error } from '@/mixins'

export default {
    components: { AssinaturaEletronicaInstacacao },
    created() {

        this.repositories = {
            dashboard: this.getConectaSusRepository('dashboard')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        data: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.dashboard.index()
                .then(({ data }) => {

                    this.data = data
                    this.loaded = true

                    return this.$nextTick()
                })
                .then(() => {

                    if (this.data.assinaturaEletronicaAtiva) {

                        this.$refs.AssinaturaEletronicaInstacacao.loadInstallation()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error],
}
</script>

<style scoped>
.content {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 57px);
    justify-content: flex-start;
    padding: 1rem;
    background-image: url('~@/assets/images/dashboard/medicina.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 300px;
}
</style>